const sfs = {
  id: 'sfs',
  name: 'Spanish Fluency School',
  shortName: 'SFS',
  domain: 'https://spanishfluencyschool.com',
  tagline: 'Fluency through real conversation',
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'es'],
  contact: {
    support: 'support@spanishfluencyschool.com',
    payments: 'payments@spanishfluencyschool.com',
    tutor: 'vic@spanishfluencyschool.com',
    info: 'info@spanishfluencyschool.com',
  },
  social: {
    instagram: 'https://instagram.com/spanishfluencyschool',
    youtube: 'https://youtube.com/@spanishfluencyschool',
  },
  calendly: 'https://calendly.com/spanishfluencyschool/sessions',
  colors: {
    primary: '#E76F51',
    dark: '#0F172A',
    light: '#F8FAFC',
    accent: '#94A3B8',
    legacyBlue: '#115173',
    legacyOrange: '#FA9F25',
  },
  assets: {
    logo: '/images/Logo/Logo SFS.png',
    icon: '/images/Logo/Logo Icon SFS.png',
    ogImage: '/og-image.jpg',
    favicon: '/favicon.ico',
  },
  manifest: {
    themeColor: '#115173',
    backgroundColor: '#ffffff',
    icon: 'static/images/Logo/Logo Icon SFS.png',
  },
  seo: {
    titleSuffix: '| Spanish Fluency School',
    ogSiteName: 'Spanish Fluency School',
  },
  // Encuadre de la oferta pública — ver
  // project-log/initiatives/active/direccion-oferta-sin-precios.md
  // showPrices oculta el número en la UI pública. NUNCA borra priceMonthly del
  // JSON de contenido: ese campo alimenta PlanConfigTab, CycleSetupWizard,
  // PlanChangeRequestModal y PaymentOptionsModal. Revertir = true.
  marketing: {
    showPrices: false,
    showImmersionInOffer: false,
    heroMedia: {
      type: 'video',
      src: '/videos/Manifiesto-Vic-English.mp4',
      alt: '',
    },
  },
  features: {
    blog: true,
    vocabularyVault: true,
    projects: true,
    calendly: true,
  },
  ai: {
    schoolId: 'sfs',
    teachingLanguage: 'es',
    studentNativeLanguage: 'en',
    schoolName: 'Spanish Fluency School',
    agentName: 'La Brújula',
  },
};

export default sfs;
